import { Injectable } from '@angular/core';
import { IndividualConfig, ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class ToastmessageService {

  constructor(private toastr: ToastrService) {}


  private withTimeOut(timeOut?: number): Partial<IndividualConfig> | undefined {
    return timeOut != null ? { timeOut } : undefined;
  }

  showSuccess(message: string, timeOut?: number) {
    this.toastr.success(message, undefined, this.withTimeOut(timeOut));
  }
  showError(message: string, timeOut?: number) {
    this.toastr.error(message, undefined, this.withTimeOut(timeOut));
  }
  showInfo(message: string, timeOut?: number) {
    this.toastr.info(message, undefined, this.withTimeOut(timeOut));
  }
  showWarning(message: string, timeOut?: number) {
    this.toastr.warning(message, undefined, this.withTimeOut(timeOut));
  }
}
